<script setup lang="ts">
const { getSchoolInfo } = useSchool()
const { data: info } = await useAsyncData('school-vision', () => getSchoolInfo())

const { elementRef: sectionRef, isVisible } = useScrollReveal()
</script>

<template>
  <section 
    id="vision"
    ref="sectionRef" 
    v-if="info?.whoAreWe" 
    class="py-section-py bg-background text-foreground relative overflow-hidden transition-colors duration-300"
  >
    <div class="container mx-auto px-container-px relative z-10">
      <div 
        class="mb-16 transition-all duration-1000 mx-auto text-center"
        :class="isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'"
      >
        <UiSectionHeader 
          titlePrefix="Qui"
          titleHighlight="Sommes-nous"
        />
      </div>
      
      <div 
        class="max-w-4xl mx-auto text-center transition-all duration-1000 delay-300"
        :class="isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'"
      >
        <div class="text-lg md:text-xl text-foreground-dim leading-relaxed whitespace-pre-line font-light">
          {{ info.whoAreWe }}
        </div>
      </div>
    </div>
  </section>
</template>


